// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-loop-menu-button-delete' )
export class AutomatorBuilderLoopMenuButtonDelete extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties

	// The item ID (post ID)
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				@click=${ this.handleLoopDelete }
			>
				${ _uo.utility.escHTML( wp.i18n.__( 'Delete', 'uncanny-automator' ) ) }
			</uo-button>
		`;
	}

	/**
	 * Handles the loop deletion
	 */
	handleLoopDelete() {
		UncannyAutomator._core.recipe.item.loop.deleteLoop(
			this.loopID
		);
	}
}
